import React from 'react';
import Amplify from 'aws-amplify';
import {
  AmplifyAuthenticator,
  AmplifySignUp,
  AmplifySignIn,
} from '@aws-amplify/ui-react';
import { Container, Row, Col } from 'reactstrap';

import awsConfig from '../../config/aws_config';
import { getText } from '../../components/Text';
import MottoHeadline from '../../components/MottoHeadline';
import GoogleSignInBtn from '../../components/GoogleSignInButton';

import HorizontalSplit from '../../components/HorizontalSplitWithText';
import { correctOrphanWordInSentence } from '../../utils/textHelpers';
import generateAuth0Request from '../../utils/auth/generateAuth0Request';

Amplify.configure(awsConfig);

const onGoogleClicked = () => {
  const auth0Req = generateAuth0Request();
  auth0Req.authorize();
};

const styles = {
  appMottoRow: {
    paddingTop: '10px',
  },
  appWelcomingDescriptionRow: {
    paddingTop: '10px',
    signInPromptText: {
      fontWeight: 600,
    },
    textAlign: 'center',
  },
  googleSignInRow: {
    paddingTop: '10px',
    textAlign: 'center',
  },
  splitterRow: {
    paddingTop: '30px',
  },
};

export default function SignIn(props) {
  const { clearGuestUserInfo } = props;

  clearGuestUserInfo();

  return (
    <Container>
      <Row style={styles.appMottoRow}>
        <Col>
          <MottoHeadline />
        </Col>
      </Row>
      <Row style={styles.appWelcomingDescriptionRow}>
        <Col>
          <p>
            {correctOrphanWordInSentence(getText('tagline'))}
          </p>
          <p style={styles.appWelcomingDescriptionRow.signInPromptText}>
            {correctOrphanWordInSentence(getText('Sign in to Continue'))}
          </p>
        </Col>
      </Row>
      <Row style={styles.googleSignInRow}>
        <Col>
          <GoogleSignInBtn buttonClicked={onGoogleClicked} />
        </Col>
      </Row>
      <Row>
        <Col style={styles.splitterRow}>
          <HorizontalSplit displayText="OR" />
        </Col>
      </Row>
      <Row>
        <Col className="amplifyForm">
          <AmplifyAuthenticator>
            <AmplifySignIn slot="sign-in" usernameAlias="email" />
            <AmplifySignUp
              slot="sign-up"
              usernameAlias="email"
              formFields={[
                {
                  type: 'email',
                  required: true,
                },
                {
                  type: 'password',
                  required: true,
                },
                {
                  type: 'phone_number',
                  placeholder: 'Your phone number',
                  required: true,
                },
              ]}
            />
          </AmplifyAuthenticator>
        </Col>
      </Row>
    </Container>
  );
}
